import { publicStorePath } from "./public-url";

/**
 * German checkout URLs carry no locale prefix. Hand-built `/${locale}/checkout`
 * produced a reachable `/de/checkout` twin and split the funnel in two.
 */
export function checkoutHref(locale: string, checkoutId: string): string {
	return `${publicStorePath(locale, "/checkout")}?checkout=${encodeURIComponent(checkoutId)}`;
}
